<template>
  <div v-if="page === 'return-confirmation'" id="return_satisfaction_holder">
    <div id="return_satisfaction"></div>
  </div>
  <div v-else>
    <div id="account_dashboard_satisfaction"></div>
  </div>
</template>

<script setup>
defineProps({
  page: {
    type: String,
    default: '',
  },
});
</script>
